"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AskQuestion = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var mona_1 = require("@artegeie/design-system/mona");
var style_1 = require("../../style");
var useFormattedMessages_1 = __importDefault(require("../../../context/useFormattedMessages"));
var useLocale_1 = __importDefault(require("../../../context/useLocale"));
var AskQuestion = function () {
    var locale = (0, useLocale_1.default)().locale;
    var messages = (0, useFormattedMessages_1.default)('misc.askQuestion');
    return (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)(style_1.Typography, { children: [messages.title, "\u00A0"] }, void 0), (0, jsx_runtime_1.jsx)(mona_1.Link, { href: "mailto:presse@arte.tv", label: messages.link, target: "Blank" }, void 0)] }, void 0);
};
exports.AskQuestion = AskQuestion;
exports.default = exports.AskQuestion;
